import React, { createContext, useState, useEffect } from "react";
import api from "../services/api";

interface ChecklistType {
	values: any;
	setValues: any;
	setFormatedTagsIds: any;
	formatedTagsIds: number[];
	processId: number | undefined;
	tags: any;
	documents: any;
	process: any;
	necessaryDocuments: any;
	stepThreeValues: any;
	reloadProcess: () => void;
	setProcessId: (id: number) => void;
	setNecessaryDocuments: (documents: any) => void;
	setStepThreeValues: (values: any) => void;
	setDocuments: (documents: any) => void;
	reloadContext: () => void;
}

const ChecklistContext = createContext<ChecklistType>({} as ChecklistType);

export const DataProvider: React.FC = ({ children }) => {
	const [values, setValues] = useState({});
	/**
	 * values:
	 * 	valores do stepTwo
	 *
	 * 	{
	 * 		[idQuestao]: resposta
	 * 	}
	 */

	const [stepThreeValues, setStepThreeValues] = useState({});
	/**
	 * StepThreeValues:
	 * 	pra separa as questoes por documento eu deixei o objeto da seguinte forma:
	 *
	 * 	{
	 * 		[idDocumento]: {
	 * 			idQuestao: {
	 * 				resposta,
	 * 				justificativa
	 * 			}
	 * 		}
	 * }
	 */

	// Ids das tags formatadas [1,2,3,4]
	const [formatedTagsIds, setFormatedTagsIds] = useState<number[]>([]);

	// Objetos dos documentos existentes no processo
	const [documents, setDocuments] = useState<any[]>();

	// Tags existentes no sistema
	const [tags, setTags] = useState();
	// Documentos necessarios que são filtrados no stepTwo
	const [necessaryDocuments, setNecessaryDocuments] = useState([]);

	const [process, setProcess] = useState<number>();
	const [processId, setProcessId] = useState<number>();

	// Quem achar isso pago uma pamonha

	const reloadProcess = async () => {
		// Função pra recarregar os documentos quando alterar uma tag

		try {
			const processResponse = await api.get(
				`/data/process&id=${processId}`,
			);

			const process = processResponse.data.data;

			setProcess(process);
			setDocuments(process.documents);
		} catch (error) {
			return error;
		}
	};

	const reloadContext = () => {
		setProcess(undefined);
		setProcessId(undefined);
		setNecessaryDocuments([]);
		setDocuments([]);
		setStepThreeValues({});
		setValues({});
	};

	useEffect(() => {
		// Carrega as tags existentes no sistema

		(async () => {
			if (processId)
				try {
					const tagsResponse = await api.get("data/documentstags");
					const documentsTags = tagsResponse.data.data;

					setTags(documentsTags);

					reloadProcess();
				} catch (reason) {
					console.log(reason);
				}
		})();
	}, [processId]);

	return (
		<ChecklistContext.Provider
			value={{
				values,
				setValues,
				setFormatedTagsIds,
				formatedTagsIds,
				processId,
				setProcessId,
				tags,
				documents,
				process,
				necessaryDocuments,
				setNecessaryDocuments,
				reloadProcess,
				stepThreeValues,
				setStepThreeValues,
				setDocuments,
				reloadContext,
			}}>
			{children}
		</ChecklistContext.Provider>
	);
};

export default ChecklistContext;
